import axios, { AxiosRequestConfig, RawAxiosRequestHeaders } from "axios";
import { backendUrl } from 'config'
import { store } from '../store'
import { sigOut } from 'store/slices/authSlice'
import { queryClient } from '../queryClient'


type IConfig = AxiosRequestConfig & {
  headers: RawAxiosRequestHeaders & {
    Authorization?: string
  }
}


const requestConfig: IConfig = {
  baseURL: backendUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': ''
  },
};


const httpClient = axios.create(requestConfig)

httpClient.interceptors.request.use(
  (config: any) => {

    const token = store.getState().auth.accessToken

    config.headers.Authorization = `Bearer ${token}`

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

httpClient.interceptors.response.use(
  response => new Promise((resolve, reject) => {
    if (response.data.error_code === 401) {
      console.log("unauthorized, logging out ...");
      // go to login page
      resolve(response)

      queryClient.clear()
      store.dispatch(sigOut())

    } else {
      resolve(response)
    }
  }),
  error => {

    console.log("------>", error);

    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }

    if (error.response.status === 401) {
      queryClient.clear()
      store.dispatch(sigOut())
    } else {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }

  }
)

export default httpClient
